import { useEffect, useState } from 'react'
import { hydra } from '@/lib/services/Hydra'
import useGlobalStore from '@/store/useGlobalStore'

export const useGetMeReferralCode = () => {
  const {
    user: { token, meReferralCode },
    setUser,
  } = useGlobalStore()

  const [isLoadingMeReferralCode, setIsLoadingMeReferralCode] = useState(false)
  const [referralCode, setReferralCode] = useState<string | null>(
    meReferralCode,
  )

  useEffect(() => {
    ;(async () => {
      if (token && !meReferralCode) {
        setIsLoadingMeReferralCode(true)

        const response = await hydra.getMeReferralCode({ hydraToken: token })

        if (response && response.items[0]) {
          const code = response.items[0].referralCode

          setReferralCode(code)

          setUser({ meReferralCode: code })
        }

        setIsLoadingMeReferralCode(false)
      }
    })()
  }, [token, meReferralCode, setUser])

  return { isLoadingMeReferralCode, referralCode }
}
